import React from 'react';
import DraggableStoryboardCellComponent from '@/views/storyboard/cell/DraggableStoryboardCellComponent';
import NotDraggableStoryboardCellComponent from '@/views/storyboard/cell/NotDraggableStoryboardCellComponent';
import {Chart, ChartQuery, ChartSettings} from 'entities/chart';

interface StoryboardCellProps {
    writeAccess: boolean;
    id: number;
    chartQuery: ChartQuery;
    chart: ChartSettings;
    deleteChart: (index: number) => void;
    onNewChartSave: (chartData: Chart, toIndex?: number) => void;
    modifyChart: (chartData: Chart) => void;
    moveChart: (dragIndex: number, hoverIndex: number) => void;
    onChartMove: () => void;
    index: number;
    hasError?: boolean;
    isRearrangeMode: boolean;
}

const ExportStoryboardCellComponent: React.FC<StoryboardCellProps> = (props) => {
    try {
        const {writeAccess, isRearrangeMode} = props;
        
        // Charts are only draggable if user has write access AND rearrange mode is enabled
        const isDraggable = writeAccess && isRearrangeMode;
        
        return isDraggable ? (
            <DraggableStoryboardCellComponent {...props} />
        ) : (
            <NotDraggableStoryboardCellComponent {...props} />
        );
    } catch (error) {
        console.error('Error in ExportStoryboardCellComponent:', error, props);
        // Fallback to non-draggable version if there's an error
        return (
            <NotDraggableStoryboardCellComponent {...props} hasError={true} />
        );
    }
};

export const StoryboardCell = ExportStoryboardCellComponent;
